export const APP_ROUTES = {
  notFound: 'not-found',
  edit: 'edit',

  auth: {
    index: '/auth/*',
    logIn: 'login',
    createPassword: 'create-password',
  },

  user: {
    index: '/*',
    dashboard: '/',
    scheduler: '/scheduler',

    settings: {
      index: '/settings/*',
      details: 'details',
      team: 'team',
      configuration: 'configuration',
      billing: 'billing',
      notifications: 'notifications',
    },
    profile: {
      index: '/profile/*',
      details: {
        index: '/profile/:id/*',
        info: 'details',
      },
      password: 'password',
      notifications: 'notifications',
      connectedAccounts: 'connected-accounts',
    },
    dancers: {
      index: '/dancers',
      create: '/dancers/create',
      notifications: 'dancers/:id/notifications',
      details: {
        index: '/dancers/:id/*',
        info: 'details',
        routines: 'routines',
        notifications: 'notifications',
        performances: 'performances',
        media: 'media',
        appointmentHistory: 'appointment-history',
      },
    },
    parents: {
      index: '/parents',
      create: '/parents/create',
      notifications: '/parents/:id/notifications',
      details: {
        index: '/parents/:id/*',
        info: 'details',
        notifications: 'notifications',
      },
    },
    team: {
      index: '/team',
      create: '/member/create',
      details: {
        info: 'details',
        index: '/members/:id/*',
      },
    },
    classes: {
      index: '/classes',
      create: '/classes/create',
      details: {
        index: '/classes/:id/*',
        info: 'details',
        dancers: 'dancers',
        schedule: 'schedule',
        scheduleEdit: 'schedule/edit',
        pricing: 'pricing',
        pricingEdit: 'pricing/edit',
      },
    },
    routines: {
      index: '/routines',
      create: '/routines/create',

      details: {
        index: '/routines/:id/*',
        info: 'details',
        performances: 'performances',
        medias: 'medias',
      },
    },
    events: {
      index: '/events',
      create: '/events/create',

      details: {
        index: '/events/:id/*',
        info: 'details',
        performances: 'performances',
      },
    },
    performances: {
      create: '/performances/create',

      details: {
        index: '/performances/:id/*',
        info: 'details',
        dancers: 'dancers',
      },
    },
    invoices: {
      index: '/invoices',
      create: '/invoices/invoices',

      details: {
        index: '/invoices/:id/details',
        edit: '/invoices/:id/edit',
        info: 'details',
      },
    },
    media: {
      index: '/media',
      details: '/media/:id',
    },
  },
};
